export const setLocalStorage = ({
  key,
  value,
}: {
  key: string
  value: string
}) => {
  localStorage.setItem(key, value)
}
//

export const getLocalStorage = (key: string) => {
  const value = localStorage.getItem(key)

  if (value) return value
}

export const removeLocalStorage = (key: string) => {
  return localStorage.removeItem(key)
}

export const clearLocalStorage = () => {
  return localStorage.clear()
}
